import React from "react";
import {
  ResponsiveContainer,
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from "recharts";

const dayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const CustomSquare = (props) => {
  const { cx, cy, size, fill, stroke, strokeWidth } = props;

  const halfSize = size / 2;
  const x = cx - halfSize;
  const y = cy - halfSize;

  return (
    <rect
      x={x}
      y={y}
      width={size}
      height={size}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      rx={2}
    />
  );
};

const CustomHeatChart = ({ data }) => {
  const hourLabels = Array.from({ length: 15 }, (_, i) => {
    const hour = i + 7;
    return `${hour}:00`;
  });

  const getColor = (value, max) => {
    if (max === 0) return "#f0f0f0";
    const intensity = Math.round((value / max) * 100);

    if (intensity === 0) return "#f0f0f0";
    if (intensity < 33) return "#B3BEC5";
    if (intensity < 66) return "#1C1C1C";
    return "#FAEF9B";
  };

  const transformedData = data.map(item => ({
    day: item.day, // 0-6 (Sunday=0)
    hour: item.hour,
    value: item.count
  }));

  const maxValue = Math.max(...transformedData.map(d => d.value), 1);

  const gridData = [];
  dayLabels.forEach((_, dayIndex) => {
    hourLabels.forEach((_, hourIndex) => {
      const hour = hourIndex + 7;
      const point = transformedData.find(d => d.day === dayIndex && d.hour === hour);
      gridData.push({
        x: hourIndex,
        y: dayIndex,
        value: point ? point.value : 0,
        actualHour: hour,
        isSevenAM: hour === 7
      });
    });
  });
  return (
    <ResponsiveContainer width="100%" height={500}>
      <ScatterChart
        margin={{ top: 30, right: 30, bottom: 30, left: 35 }}
      >
        {/* <CartesianGrid strokeDasharray="3 3" /> */}
        <XAxis
          type="number"
          dataKey="x"
          domain={[0, 14]}
          ticks={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]}
          tickFormatter={(index) => hourLabels[index]}
          axisLine={false}
          tickLine={false}
          interval={0}
          tick={{ fontSize: 12 }}
        />
        <YAxis
          type="number"
          dataKey="y"
          domain={[-0.5, 6.5]}
          ticks={[0, 1, 2, 3, 4, 5, 6]}
          tickFormatter={(index) => dayLabels[index]}
          axisLine={false}
          tickLine={false}
          interval={0}
          tick={{ fontSize: 12 }}
        />
        <Scatter
          data={gridData}
          shape={<CustomSquare size={60} />}
        >
          {gridData.map((entry, index) => (
            <Cell
              key={index}
              fill={entry.isSevenAM ? "transparent" : getColor(entry.value, maxValue)}
              stroke="#fff"
              strokeWidth={1}
            />
          ))}
        </Scatter>
      </ScatterChart>
    </ResponsiveContainer>
  );
};

export default CustomHeatChart;